import React from 'react';
import {
  Tag,
  TagLabel,
  TagLeftIcon,
  TagCloseButton,
  Box,
} from '@chakra-ui/react';
import PropTypes from 'prop-types';

// A single label chip. Color comes from the label; text stays readable on
// the soft tinted background. Used on the Labels page and, later, the
// merchant list column.
const LabelBadge = ({ label, size = 'sm', onRemove, isSolid = false }) => {
  if (!label) return null;
  const color = label.color || '#718096';

  return (
    <Tag
      size={size}
      borderRadius="full"
      variant="subtle"
      bg={isSolid ? color : `${color}1F`}
      color={isSolid ? 'white' : color}
      fontWeight="600"
      maxW="100%"
    >
      <TagLeftIcon
        as={Box}
        boxSize="8px"
        borderRadius="full"
        bg={isSolid ? 'white' : color}
        mr="6px"
      />
      <TagLabel isTruncated>{label.name}</TagLabel>
      {onRemove && (
        <TagCloseButton
          onClick={(e) => {
            e.stopPropagation();
            onRemove(label);
          }}
        />
      )}
    </Tag>
  );
};

LabelBadge.propTypes = {
  label: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    color: PropTypes.string,
  }),
  size: PropTypes.string,
  onRemove: PropTypes.func,
  isSolid: PropTypes.bool,
};

export default LabelBadge;
